import { type ErrorCodeMap } from './types';

export const generalErrorCodes: ErrorCodeMap = {
  ACCESSIBILITY_PERMISSION: 'desktop.errors.accessibilityPermission',
  NOT_CONFIGURED: 'desktop.errors.notConfigured',
};
